import { baseUrl, fetchWithAuth } from "./index";

export async function listProperties() {
  return fetchWithAuth(`${baseUrl}/properties/`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
}

export async function listAllApprovedProperties(page, limit, filters = {}) {
  const params = new URLSearchParams();

  // Parâmetros básicos
  params.append("page", page);
  params.append("limit", limit);

  // Itera sobre os filtros para adicionar na URL
  Object.keys(filters).forEach((key) => {
    const value = filters[key];

    if (value === null || value === undefined || value === "") {
      return; // Pula valores vazios
    }

    if (Array.isArray(value)) {
      // Se for array (ex: bairros, dorms), adiciona vários params com o mesmo nome
      // ?bairros=Forte&bairros=Boqueirao
      value.forEach((item) => params.append(key, item));
    } else {
      // Valor simples
      params.append(key, value);
    }
  });

  // A chamada final fica algo como: /properties/approved?page=1&limit=30&city=Santos...
  return fetchWithAuth(`${baseUrl}/properties/approved?${params.toString()}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
}

export async function listApprovedPropertiesNumber(){
  return fetchWithAuth(`${baseUrl}/properties/approved`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    }
  })
}

export async function getApprovedLocations(){
  return fetchWithAuth(`${baseUrl}/properties/locations`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    }
  })
}

export async function createPropertie(propertieData) {
  return fetchWithAuth(`${baseUrl}/create-properties`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify(propertieData),
  });
}

export async function getPropertieById(propertieId) {
  return fetchWithAuth(`${baseUrl}/properties/${propertieId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
}

export async function updatePropertie(propertieId, updatedData) {
  const formData = new FormData();
  // Adiciona campos normais
  Object.entries(updatedData).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      // Se for array (ex.: imagens ou contatos)
      value.forEach((v) => {
        formData.append(key, v);
      });
    } else {
      formData.append(key, value);
    }
  });

  return fetch(`${baseUrl}/properties/${propertieId}`, {
    method: "PUT",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      // ❌ Importante: NUNCA definir Content-Type manualmente com FormData
    },
    body: formData,
  });
}

export async function deletePropertie(propertieId) {
  return fetchWithAuth(`${baseUrl}/properties/${propertieId}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
}

export async function deletePropertiesBatch(ids) {
  return fetchWithAuth(`${baseUrl}/properties/batch`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({ ids }),
  });
}
